module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "titlepage"
    }
  }, [_c('h1', {
    staticClass: "booktitle"
  }, [_vm._v("Present Perfect")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Finding God in the Now")]), _vm._v(" "), _c('h3', {
    staticClass: "author"
  }, [_vm._v("Gregory A. Boyd")]), _vm._v(" "), _c('p', {
    staticClass: "othertext"
  }, [_c('b', [_vm._v("Bestselling Author of "), _c('i', [_vm._v("The Myth of a Christian Nation")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "publogo"
  }, [_c('img', {
    attrs: {
      "alt": "publisher logo",
      "src": "images/logo.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6da21fa5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004titlepage.vue
// module id = 66
// module chunks = 0